import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Location } from '../../app/ApiGen';
import { Normalised } from '../../utils/request';
import { LocationState } from './types';

const initialState: LocationState = {
  loading: false,
  error: undefined,
  current: undefined,
  selectedItemId: undefined,
};

const locationSlice = createSlice({
  name: 'locationSlice',
  initialState,
  reducers: {
    getCurrentLocationAction: (state: LocationState, action: PayloadAction<{ selectedItemId: string }>) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: true,
      error: undefined,
    }),
    setCurrentLocationAction: (state: LocationState, action: PayloadAction<{ location: Normalised<Location> }>) => ({
      ...state,
      selectedItemId: action.payload.location.id,
      loading: false,
      error: undefined,
      current: action.payload.location,
    }),
    setLocationErrorAction: (
      state: LocationState,
      action: PayloadAction<{ error: Error; selectedItemId: string }>,
    ) => ({
      ...state,
      selectedItemId: action.payload.selectedItemId,
      loading: false,
      error: action.payload.error,
    }),
    clearCurrentLocationAction: (state: LocationState) => ({
      ...state,
      selectedItemId: undefined,
      loading: false,
      error: undefined,
      current: undefined,
    }),
  },
});

export const { actions: locationActions, reducer: locationReducers } = locationSlice;
